export const chainSort = <T>(...sortFunctions: ((a: T, b: T) => number)[]) => (
  a: T,
  b: T
) =>
  sortFunctions.reduce((result, fn) => (result === 0 ? fn(a, b) : result), 0);
